import { render, staticRenderFns } from "./ShiftEdit.vue?vue&type=template&id=1b800446"
import script from "./ShiftEdit.js?vue&type=script&lang=js&external"
export * from "./ShiftEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports